import axios from 'axios';
import config from '../helpers/config';

const baseUrl = config.web3BaseUrl;
const publicAuthConfig = {
  headers: {
    Authorization: config.web3AuthKey,
  },
};

export const getNftData = async params => {
  try {
    const res = await axios.get(`${baseUrl}/api/v1/nft`, {
      ...publicAuthConfig,
      params,
    });
    const data = res.data;

    return {
      data: data,
      error: null,
    };
  } catch (e) {
    return {
      data: null,
      error: e,
    };
  }
};

export const getNftStatus = async params => {
  try {
    const res = await axios.post(`${baseUrl}/api/v1/token-status`, params, {
      ...publicAuthConfig,
    });
    const data = res.data;
    return {
      data: data,
      error: null,
    };
  } catch (e) {
    return {
      data: null,
      error: e,
    };
  }
};

export const transferNft = async params => {
  try {
    const res = await axios.post(`${baseUrl}/api/v1/transfer-nft`, params, {
      ...publicAuthConfig,
    });
    const data = res.data;

    return {
      data: data,
      error: null,
    };
  } catch (e) {
    return {
      data: null,
      error: e?.response?.data?.message,
    };
  }
};

export const getMetamaskAddressStatus = async params => {
  try {
    const res = await axios.get(`${baseUrl}/api/v1/wallet-addresses`, {
      ...publicAuthConfig,
      params,
    });
    const data = res.data;
    return {
      data: data,
      error: null,
    };
  } catch (e) {
    return {
      data: null,
      error: e,
    };
  }
};
